import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Air - Ketahui Berapa Banyak Air yang Dibutuhkan Tubuh Anda";
const DESCRIPTION =
  "Berapa banyak air yang dibutuhkan tubuh? Hitung jumlah air yang tepat yang dibutuhkan tubuh Anda berdasarkan berat badan Anda untuk menghindari dehidrasi dan penyakit dengan langkah mudah.";
const KEYWORDS =
  "kalkulator jumlah air, minum air, kesehatan tubuh, kebutuhan air harian";
const OG_URL =
  "https://do-calculate.com/calculator/id/daily-water-intake-calculator/";
function WaterIntakeCalculator() {
  const [weight, setWeight] = useState("");
  const [activityLevel, setActivityLevel] = useState("low");
  const [climate, setClimate] = useState("moderate");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleActivityLevelChange = (event) => {
    setActivityLevel(event.target.value);
  };
  const handleClimateChange = (event) => {
    setClimate(event.target.value);
  };
  const calculateWaterIntake = () => {
    const weightNum = parseFloat(weight);
    if (isNaN(weightNum) || weightNum <= 0) {
      setError("Masukkan berat badan yang valid");
      setResult(null);
      return;
    }
    let baseIntake = weightNum * 0.033;
    if (activityLevel === "moderate") {
      baseIntake *= 1.2;
    } else if (activityLevel === "high") {
      baseIntake *= 1.4;
    }
    if (climate === "hot") {
      baseIntake *= 1.3;
    } else if (climate === "cold") {
      baseIntake *= 0.9;
    }
    const waterInLiters = baseIntake.toFixed(2);
    const waterInGlasses = (waterInLiters / 0.25).toFixed(0);
    setResult({ liters: waterInLiters, glasses: waterInGlasses });
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator jumlah air harian membantu Anda menentukan jumlah air yang tepat yang harus Anda minum setiap hari berdasarkan berat badan, tingkat aktivitas, dan iklim tempat Anda tinggal. Kalkulator ini dapat membantu Anda menjaga hidrasi tubuh dan kesehatan secara umum. Minum cukup air setiap hari sangat penting untuk membantu menjaga fungsi tubuh normal, termasuk mengatur suhu tubuh, mengangkut nutrisi, dan melembabkan kulit. Selain itu, minum air dalam jumlah yang tepat dapat membantu meningkatkan pencernaan, mengurangi rasa lelah, dan meningkatkan tingkat energi Anda.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-10 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Jumlah Air Harian
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weight" className="form-label ms-2">
                      Berat Badan (kg)
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weight"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="kg"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="activityLevel" className="form-label ms-2">
                      Tingkat Aktivitas
                    </label>
                  </b>
                  <select
                    id="activityLevel"
                    value={activityLevel}
                    onChange={handleActivityLevelChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="low">Rendah</option>
                    <option value="moderate">Sedang</option>
                    <option value="high">Tinggi</option>
                  </select>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="climate" className="form-label ms-2">
                      Iklim
                    </label>
                  </b>
                  <select
                    id="climate"
                    value={climate}
                    onChange={handleClimateChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="moderate">Sedang</option>
                    <option value="hot">Panas</option>
                    <option value="cold">Dingin</option>
                  </select>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateWaterIntake}
                  >
                    Hitung
                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-7">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Terjadi Kesalahan:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <h4>Hasil:</h4>
                      <hr />
                      <p>Jumlah air harian yang direkomendasikan adalah:</p>
                      <p style={{ fontWeight: "bold" }}>
                        Anda harus minum {result.glasses} gelas air, setara dengan {result.liters} liter.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h2 style={{ fontSize: "18px" }}>Bagaimana Cara Menghitung Jumlah Air yang Dibutuhkan Tubuh Saya Setiap Hari</h2>
            </div>
            <div className="info-section-body">
              <p>{DESCRIPTION}</p>
              <div>
                <h3 style={{ fontSize: '16px' }}>Berapa Banyak Air yang Dibutuhkan Tubuh?</h3>
                <p>Hitung jumlah air yang tepat yang dibutuhkan tubuh Anda berdasarkan berat badan Anda untuk menghindari dehidrasi dan penyakit dengan langkah mudah menggunakan kalkulator air. Kalkulator jumlah air yang dibutuhkan tubuh setiap hari.</p>
                <p>Apakah Anda hanya minum air saat merasa haus? Ini adalah kebiasaan yang pasti salah; karena rasa haus adalah peringatan bahwa tubuh Anda mengalami dehidrasi dan Anda harus segera minum air. Kalkulator ini membantu Anda menghitung jumlah air yang harus Anda minum setiap hari (berdasarkan berat badan dan usia Anda) untuk menghindari dehidrasi.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>Berapa Liter Air yang Dibutuhkan Tubuh per Hari?</h3>
                <p>Masukkan usia dan berat badan Anda ke dalam kalkulator air untuk mengetahui berapa banyak air yang harus Anda minum setiap hari untuk menjaga kesehatan dan menghindari dehidrasi.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>Jumlah Air yang Direkomendasikan per Hari</h3>
                <p>Jumlah air yang direkomendasikan per hari sangat bervariasi berdasarkan faktor-faktor seperti usia, jenis kelamin, ukuran tubuh, tingkat aktivitas harian, dan lingkungan fisik. Kalkulator air mempertimbangkan semua faktor ini untuk memberikan perhitungan yang akurat.</p>
                <p>Misalnya, atlet biasanya membutuhkan cairan tambahan karena kehilangan air akibat aktivitas fisik yang intens. Demikian pula, orang yang tinggal di iklim tropis mungkin membutuhkan lebih banyak air untuk menggantikan keringat berlebih karena suhu tinggi.</p>
                <p>Wanita hamil dan menyusui juga perlu meningkatkan asupan cairan untuk mendukung kebutuhan tubuh mereka dan kesehatan bayi mereka. Ini dapat berkisar dari 500 ml hingga 2 liter per hari.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>Mengapa Minum Air Itu Penting?</h3>
                <p>Air sangat penting untuk kehidupan dan dianggap sebagai nutrisi paling vital. Ketiadaannya dapat berakibat fatal dalam hitungan hari. Air penting untuk fungsi fisik dan mental kita, dan penting untuk semua fungsi metabolisme kita termasuk pengaturan suhu, transmisi saraf, dan banyak reaksi kimia. Kita mempertahankan keadaan hidrasi alami atau keseimbangan air melalui kontrol asupan dan kehilangan air.</p>
                <p>Anehnya, pertanyaan tentang jumlah air yang optimal masih belum jelas dan tidak ditentukan secara tepat, tetapi kisaran perkiraan dan menghindari rasa haus dianggap sebagai indikator yang baik untuk menghindari dehidrasi.</p>
                <p>Ikuti 3 langkah sederhana menggunakan kalkulator air untuk mengetahui apakah Anda minum cukup air. Kalkulator akan menghitung tingkat hidrasi Anda berdasarkan informasi yang Anda berikan tentang diri Anda dan kebiasaan minum air harian Anda.</p>
              </div>
              <hr />
              <div>
                <p>Beberapa rekomendasi ini berasal dari <a href="https://www.medindia.net" rel="nofollow noreferrer">medindia.net</a> dan <a href="https://www.hydrationforhealth.com/en/hydration-tools/hydration-calculator/" rel="nofollow noreferrer">Hydration for Health</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WaterIntakeCalculator;